import { createAction, props } from '@ngrx/store';

export const loadTemplates = createAction('[Employee] Load Templates');
export const loadTemplatesSuccess = createAction('[Employee] LoadTemplates Success', props<{ payload: any }>());
export const loadTemplatesFail = createAction('[Employee] Load Templates Fail', props<{ payload: any }>());

export const loadMoreTemplates = createAction('[Employee] Load More Templates', props<{ payload: {skip: number, limit: number} }>());
export const loadMoreTemplatesSuccess = createAction('[Employee] Load More Templates Success', props<{ payload: any }>());
export const loadMoreTemplatesFail = createAction('[Employee] Load More Templates Fail', props<{ payload: any }>());

export const loadAllTemplates = createAction('[Employee] Load All Templates');
export const loadAllTemplatesSuccess = createAction('[Employee]  Load All Templates Success', props<{ payload: any }>());
export const loadAllTemplatesFail = createAction('[Employee] Load All Templates Fail', props<{ payload: any }>());

export const searchTemplates = createAction('[Employee] Search Templates Templates', props<{ payload: {query: string, unit: string} }>());
export const searchTemplatesSuccess = createAction('[Employee] Search Templates Templates Success', props<{ payload: any }>());
export const searchTemplatesFail = createAction('[Employee] Search Templates Templates Fail', props<{ payload: any }>());
